/* eslint-disable react-hooks/exhaustive-deps */
import { Tag } from 'antd';
import React, { useEffect, useState } from 'react';

const Total100 = ({
  item,
  inputName,
  data,
  input,
  placeholder,
  withPlaceholder,
}) => {
  const [values, setValues] = useState(null);
  const [iD, setID] = useState('');

  useEffect(() => {
    const inputData = item ? item[inputName] : data[inputName];
    const { options } = input;
    setValues((inputData || []).map((d) => {
      const option = options.find(o => o.value === d.type);
      if (option) {
        return {
          type: option.label,
          value: d.value,
        };
      }
      return null;
    }));
    setID(inputData);
  }, []);

  return values && values.length ? values.map(val => (
    val && val.type ? <Tag>{val.type}: {val.value}%</Tag> : placeholder(val, inputName, withPlaceholder)
  )) : placeholder(iD, inputName, withPlaceholder);
};

export default Total100;
